<div [class.small-fonts]="small()" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
    <div fxFlex="none" class="profile-image-wrapper">
        @if (profileImageSrc()) {
            <cipo-img-base64
                [base64]="profileImageSrc()"
                [height]="80"
                radius="50%"
                data-testid="user-profile-header-logo"></cipo-img-base64>
        } @else {
            <mat-icon class="user-nologo" data-testid="user-profile-header-no-logo" aria-hidden="true">
                account_circle
            </mat-icon>
        }
        @if (enableProfileUpload()) {
            <button
                type="button"
                class="profile-upload-overlay cipo--btn-reset"
                data-testid="user-profile-header-upload"
                [attr.aria-label]="'a11y.userProfile.uploadPhoto' | translate"
                (click)="triggerFileInput()">
                <mat-icon aria-hidden="true" class="cipo-text--black-50">photo_camera</mat-icon>
            </button>
            <input
                type="file"
                #fileInput
                data-testid="user-profile-header-upload-input"
                accept="image/*"
                style="display: none"
                (change)="onProfileImageSelected($event)" />
        }
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
        <h3 class="name" data-testid="user-profile-header-name">{{ firstName() }} {{ lastName() }}</h3>
        <p
            class="email cipo--cursor--pointer"
            data-testid="user-profile-header-email"
            (click)="copyEmailToClipboard()"
            title="{{ 'userProfile.copyEmail' | translate }}">
            {{ email() }}
        </p>
        <cipo-see-more
            class="role"
            [class.small-see-more]="small()"
            [text]="roles()"
            [limit]="maxRoles()"
            data-testid="user-profile-header-roles"></cipo-see-more>
        <p class="organization" data-testid="user-profile-header-organization">{{ organizationName() }}</p>
    </div>
</div>
